module.exports = __webpack_public_path__ + "img/source05_04.94eb8369.png";